<app-header
  [logo]="logo"
  [logoHeight]="logoHeight"
  [address]="address"
  [phoneNumber]="phoneNumber"
  [textNumber]="textNumber"
  [logoUrl]="logoUrl"
  [showBanner]="showBanner"
  [showBannerOnMobile]="showBannerOnMobile"
  [customContactInfo]="customContactInfo"
  [isMobile]="isMobile"
></app-header>
<div class="app-content">
  <router-outlet></router-outlet>
</div>
